import NeoLeoAvatar from '../../assets/img/neo-leo.png';
import { cn } from '../../utils/classUtils';

interface NeoLeoIconProps {
  handleNeoLeoToggle: () => void;
  isNeoLeoOpen: boolean;
}

const NeoLeoMobileIcon: React.FC<NeoLeoIconProps> = ({
  handleNeoLeoToggle,
  isNeoLeoOpen,
}) => {
  return (
    <div
      className={cn(
        'flex flex-row items-center justify-center md:hidden absolute bottom-20 right-5 pb-2',
        isNeoLeoOpen ? 'hidden' : 'block',
      )}
    >
      <div
        className='flex flex-row items-center gap-x-1 bg-reskin-regent-900 text-white py-2 px-2 rounded-full'
        onClick={handleNeoLeoToggle}
      >
        <img className='w-7 h-7' src={NeoLeoAvatar} alt='neo-leo-avatar' />
        <p className='text-white text-sm font-medium font-inter'>Ask Leo</p>
      </div>
    </div>
  );
};

export default NeoLeoMobileIcon;
